<template>

  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="8" lg="4">
        <h1 class="text-center mb-2 mt-6">
          {{ this.$store.state.client_settings.APPNAME }}
        </h1>

        <h3 class="text-center mb-4">
          Accedi a {{ this.$store.state.client_settings.APPNAME }}
        </h3>

        <v-alert
            v-show="access_token != null"
            type="info"
            class="mt-2 py-2 info"
        >
          Sei già loggato
          <div class="float-right">
            <v-btn small class="mx-2 light" outlined to="/Menu">
              <v-icon left>mdi-home</v-icon>
              Home
            </v-btn>
            <v-btn small class="mx-2 light" outlined @click="logout">
              <v-icon left>mdi-logout-variant</v-icon>
              Logout
            </v-btn>
          </div>
        </v-alert>

        <v-form
            ref="form"
            v-model="valid"
            :lazy-validation="lazy"
            @submit.prevent="submit"
        >
          <v-text-field
              outlined
              :id="new Date().getTime().toString()"
              v-model="form.email"
              placeholder
              :append-icon="'mdi-email-outline'"
              :rules="emailRules"
              label="E-mail"
              required
          ></v-text-field>
          <v-text-field
              outlined
              v-model="form.password"
              autocomplete="off"
              placeholder
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              :rules="passwordRules"
              label="Password"
              @click:append="showPassword = !showPassword"
              required
          ></v-text-field>
          <v-text-field
              outlined
              v-model="form.codice_studio"
              autocomplete="off"
              placeholder
              append-icon="mdi-office-building"


              label="Codice Studio"
              >

          </v-text-field>
          <v-btn
              :disabled="!valid"
              type="submit"
              large
              color="primary"
              block
              class="mr-4"
          >Accedi
          </v-btn
          >
          <v-row>
            <MjGoogleLoginButton/>
          </v-row>

          <v-alert v-if="show_error" type="warning" class="mt-2 py-2 warning">
            <span v-text="login_error_text"></span>
          </v-alert>
          <hr class="grey lighten-5 mt-5 ml-3 mr-3"/>
          <!-- <div class="mt-5 text-center">
            <router-link to="/utente/recupera_password">Ho dimenticato la password</router-link>
          </div>
          <div class="mt-2 text-center">
            <router-link to="/utente/registrati">Registrati per creare un account</router-link>
          </div> -->
        </v-form>
      </v-col>
    </v-row>
    <v-card class=" mx-auto mt-6 elevation-0" width="100%">
      <v-card-text justify="center" class="text-center">
        <div>PROCEDURES CLOUD S.R.L.s</div>
        <div>C.F.-P.IVA. IT02092760384</div>
        <DIV>C.so Giovecca, 102 - 44121 - FERRARA</div>
          <div>Tel/Fax <a href="tel:+3905321918238">+39 0532 1918238</a><br/></DIV>
        <p>
          EMAIL <a href="mailto:info@procedures.cloud" target="_blank">info@procedures.cloud</a><br>
          PEC <a href="procedures.cloud@pec.it" target="_blank">procedures.cloud@pec.it</a><br>
          WEB <a href="http://www.procedures.cloud" target="_blank">www.procedures.cloud</a>
        </p>
      </v-card-text>
    </v-card>

  </v-container>
</template>

<script>
import store from "@/store.js";
import MjGoogleLoginButton from "@/components/MjGoogleLoginButton.vue"


export default {
  name: "Login",
  store,
  //definiamo i componenti che desideriamo utilizzare in questo componente per evitare che venga creato un js troppo grande nella build
  components: {MjGoogleLoginButton},
  computed: {
    access_token: function () {
      return store.state.token_obj.access_token;
    },
  },


  data: () => ({
    showLogged: true,
    show_error: false,
    login_error_text: "",
    valid: true,
    showPassword: false,

    form: {
      password: "",
      email: "",
      codice_studio: "",
    },
    passwordRules: [
      (v) => !!v || "Password Obbligatora is required",
      (v) => (v && v.length >= 8) || "Digita almeno 8 caratteri",
    ],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    lazy: false,

  }),
  methods: {
    submit() {

      // window.localStorage.setItem("codice_studio",);
      store.commit('update_studio_data',{studio_code:this.form.codice_studio});

      this.show_error = false;
      this.login_error_text = "";
      if (this.$refs.form.validate()) {
        const user = {
          email: this.form.email,
          password: this.form.password,
          codice_studio: this.form.codice_studio,
        };
        store
            .dispatch("login", user)
            .then(() => {
              store.dispatch("loadStudioData", this.form.codice_studio)

              this.$router.replace("/menu");


            })
            .catch((e) => {
              this.show_error = true; //usa arrow function per avere il this del componente
              this.login_error_text = e.response.data.message;
            });
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    logout() {
      this.$store.dispatch("logout").finally(() => {
        this.$router.replace("/utente/login");
      });
    },
  },
  watch: {
    form: {
      handler: function () {
        this.show_error = false;
        return true;
      },
      deep: true,
    },
  },
};
</script>
